import React, { Component } from 'react';
import './WeighTabs.css';
import _ from 'lodash';


class WeighTabs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            segmentList : [],
            getSegmentsNameList: false,
            scoreValArr: [],
        }
    }

    componentWillMount() {
        if(!_.isEmpty(this.props.attractivenessData)){
            this.setState({
                data:this.props.attractivenessData
            })
        }
        if(this.props.tabs && !_.isEmpty(this.props.tabs) && _.isEmpty(this.state.scoreValArr)){
            this.props.tabs.map((item, key) => {
                let body = {
                    projectId:this.props.projectId,
                }
                this.props.getSegmentsName(body);
            });
        }

    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.attractivenessData &&  nextProps.addedNewItemState ){
            this.props.addedNewItem(false)
            this.setState({
                data:nextProps.attractivenessData
            })
        }
        if(nextProps.tabs && !_.isEmpty(nextProps.tabs) && !this.state.getSegmentsNameList){
            nextProps.tabs.map((item, key) => {
                let body = {
                    projectId:this.props.projectId,
                }
                this.props.getSegmentsName(body);
            });
            this.setState({getSegmentsNameList : true});
        }

        if( !_.isEmpty(nextProps.getSegmentData) && _.isEmpty(this.state.scoreValArr)) {
            
            nextProps.attractivenessData.map((item, key) => {
                nextProps.getSegmentData.Items.map((segmentdataItem, key) => {
                    if( item.groupId === segmentdataItem.groupId){
                        this.state.scoreValArr.push({
                            attractivnessId: item.attractivnessId,
                            attractivnessName: item.name,
                            segmentId: segmentdataItem.segmentId,
                            segmentName: segmentdataItem.name
                        }) 
                    }
                    
                })
            })
        }
    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                <div className='rect1'/>
                <div className='rect2'/>
                <div className='rect3'/>
                <div className='rect4'/>
                <div className='rect5'/>
                </div>
            </div>
        );
    }

    render() {
        let tabs = this.props.tabs.map((item,key) => {
            return (
                <li className="nav-item" key={item.groupName} onClick={()=>this.props.onTabChange(key)}>
                    <a data-toggle="tab" className={key === this.props.tabStep ? "nav-link active show" :"nav-link"} href={`#${item.groupName}`} aria-controls={`${item.groupName}`} aria-selected="true">{item.groupName} </a>
            </li>)
        });

        let tabsContent;
        
        if(this.props.getSegmentData && !_.isEmpty(this.props.getSegmentData.Items)){
            let weightingNumber = [];
            
            tabsContent = this.props.tabs.map((tabsItem, tabsKey) => {
                let tabWaitingAmount = 0;
                const groupName = this.props.tabs.find(r => r.groupId === tabsItem.groupId).groupName;
                    
                    return(
                        <div id={groupName} className={tabsKey === this.props.tabStep ? "tab-pane fade show active tabContentdiv": "tab-pane fade tabContentdiv"} role="tabpanel" key={tabsKey}>
                        
                            <div className="row">
                                <table className="table table-bordered segmentationTable">
                                    <thead>
                                        <tr>
                                            <th >Criteria of Attractiveness</th>
                                            <th className="weighting-th">Weighting <br/> (1-100) </th>
                                            { this.props.getSegmentData.Items.map((segmentItem, key) => {
                                                if( tabsItem.groupId === segmentItem.groupId ){
                                                    return(
                                                        <th className='opacity-cell'>
                                                            <div className='full-title'>
                                                                {segmentItem.name}
                                                            </div>
                                                            <div className='half-title rating'>
                                                                Rating <br/> <span>(1-10)</span> 
                                                            </div>
                                                            <div className='half-title'>
                                                                Score
                                                            </div>
                                                        </th>
                                                    )
                                                }
                                            })}
                                        </tr>         
                                    </thead> 
                                    <tbody>
                                        { this.props.attractivenessData.map((item, key) => {

                                            if(tabsItem.groupId === item.groupId){

                                                let defaultData = this.props.weighting.find(r => r.attractivnessId === item.attractivnessId);

                                                return(
                                                    <tr>
                                                        <td>
                                                            {item.name}
                                                        </td>
                                                        <td className='input-box'>
                                                            <input value={defaultData ? defaultData.value : ''} type='number' onChange={(e)=>this.props.onChangeWeightingValue(e, item)}  />
                                                        </td>

                                                        { this.props.getSegmentData.Items.map((segmentdataItem, key) => {

                                                            let getselectData = this.props.segmentAttractivness.find(r => (r.attractivnessId === item.attractivnessId) && (r.segmentId ===  segmentdataItem.segmentId ));

                                                            let number = this.props.weighting.find(r => r.attractivnessId === item.attractivnessId);   
                                                            
                                                            let score = number ? (getselectData ? +getselectData.value * +number.value : +number.value)  : 0;

                                                            if(tabsItem.groupId === segmentdataItem.groupId){
                                                                
                                                                let selectDefaultData = this.props.segmentAttractivness.find(r => (r.attractivnessId === item.attractivnessId) && (r.segmentId ===  segmentdataItem.segmentId ));
                                                                
                                                                return(
                                                                    <td className='opacity-cell'> 
                                                                        <div className='half-td'>
                                                                        <select disabled  className='form-control' 
                                                                            value={selectDefaultData ? selectDefaultData.value : 1}  
                                                                            onChange={(e)=>this.props.onChangeRatingValue(e)} style={{outline: 'none'}}>
                                                                                <option value='1'>1</option>
                                                                                <option value='2'>2</option>
                                                                                <option value='3'>3</option>
                                                                                <option value='4'>4</option>
                                                                                <option value='5'>5</option>
                                                                                <option value='6'>6</option>
                                                                                <option value='7'>7</option>
                                                                                <option value='8'>8</option>
                                                                                <option value='9'>9</option>
                                                                                <option value='10'>10</option>
                                                                            </select>
                                                                        </div>
                                                                        <div className="half-td score-box">
                                                                            {score}
                                                                        </div>
                                                                    </td>
                                                                )
                                                            }
                                                        })}  
                                                    </tr>
                                                )
                                            }
                                        })}

                                        <tr className='last-row'>
                                            { 
                                                this.props.attractivenessData.map((item, key) => {
                                                    if(tabsItem.groupId === item.groupId){

                                                        tabWaitingAmount = +tabWaitingAmount + +(this.props.weighting.find(r => r.attractivnessId === item.attractivnessId) ? this.props.weighting.find(r => r.attractivnessId === item.attractivnessId).value : 0) 
                                                    }
                                                })
                                            
                                            }


                                            <td></td>

                                            <td className='first-value'>
                                                <strong>{tabWaitingAmount}</strong>
                                            </td>

                                            { this.props.getSegmentData.Items.map((segmentItem, 
                                            key) => {

                                                let colScoreArr = [];
                                                this.state.scoreValArr.map((child, 
                                            key) => {
                                                    if( child.segmentId === segmentItem.segmentId ){
                                                        colScoreArr.push(child);
                                                    }
                                                });

                                                let scoreNumberArr = [];
                                                colScoreArr.map((score, 
                                                    key) => {

                                                        let getselectData = this.props.segmentAttractivness.find(r => (r.attractivnessId === score.attractivnessId) && (r.segmentId ===  segmentItem.segmentId ));

                                                        let number = this.props.weighting.find(r => r.attractivnessId === score.attractivnessId);   
                                                        
                                                        let value = number ? (getselectData ? +getselectData.value * +number.value : +number.value)  : 0;

                                                        scoreNumberArr.push(value);
                                                })

                                                let scoreNumber = 0;
                                                scoreNumberArr.map((number, 
                                                    key) => {
                                                        return scoreNumber = scoreNumber + number;
                                                    });

                                                if(tabsItem.groupId === segmentItem.groupId){
                                                    
                                                    return (
                                                        <td className='opacity-cell'> 
                                                            <div className='half-td color-td'>0</div>
                                                            <div className='half-td amount-box'><strong>{scoreNumber}</strong></div>
                                                        </td>
                                                    )
                                                }
                                            })}
                                        </tr> 
                                    </tbody>
                                </table>
                            </div>
                        
                        </div>
                    )
                
            })
        }

        return (
            <div className='criteria-tabs-content attractiveness-tab-content'>
                <ul className="nav nav-tabs benefitsNavTabs" role="tablist" id="myTab">
                    {tabs}
                </ul>
                <div className="tab-content benefitsTabcontent" id="myTabContent" >
                    {tabsContent}
                </div>
            </div>
        )
    }
}
export default (WeighTabs);


// WEBPACK FOOTER //
// ./src/components/SegmentAttractiveness/AttractivenessWeight/WeighTabs/WeighTabs.jsx